/* eslint-disable padding-line-between-statements */
import { Loader, useModal, InlineLoader } from '@jutro/components';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { wizardMessages } from 'twia-portals-wizard-components-ui';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import React, {
    useCallback,
    useContext,
    useEffect,
    useState,
} from 'react';
import { CustomQuoteService, LoadSaveService } from 'twia-capability-quoteandbind-residential';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import ErrorPopupUtil from 'ent-components-platform-react/util/ErrorPopupUtil';
import messages from './PaymentDetailsPage.messages';
import metadata from './PaymentDetailsPage.metadata.json5';
import styles from './PaymentDetailsPage.module.scss';
import PaymentPlansTable from '../../components/PaymentPlans/PaymentPlansTable';
import InstallmentsPopup from '../../components/InstallmentsPopup/InstallmentsPopup';
import TWIASubmissionHelper from '../../util/TWIASubmissionHelper';
import TWIAPolicyContactRoleHelper from '../../util/TWIAPolicyContactRoleHelper';
import Echeck from '../../components/Echeck/Echeck';

import { Link } from '@jutro/router';

function TWIAPaymentDetailsPage(props) {
    const {
        wizardData: submissionVM,
        updateWizardData,
        jumpTo,
        steps
    } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const [isLoading, setIsLoading] = useState(false);
    const [emailMessage, setEmailMessage] = useState([]);
    const translator = useTranslator();
    const history = useHistory()
    const { authHeader } = useAuthentication();
    const { isComponentValid, onValidate, disregardFieldValidation } = useValidation('TWIAPaymentDetailsPage');
    const [bindDataVM, setBindDataVM] = useState(submissionVM.bindData);
    const offeredQuoteData = _.get(submissionVM, `quoteData.offeredQuotes.value`)[0]
    const eftEnabled = _.get(submissionVM, 'bindData.eftEnabled_TWIA.value');
    const jobID = submissionVM.quoteID.value;
    const sessionID = submissionVM.sessionUUID.value;
    const [showError, setShowError] = useState(false);
    const { showModal, showAlert, showConfirm } = useModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const NO_PAYMENT_OPTION_METHODS = ['prem_fina_other', 'ins_direct_pay', 'echeck', 'eft']
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const ADDITIONAL_INTEREST_OPTIONS = ['prem_fina_other', 'mortgagee_escrow'];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const DISABLE_SUBMIT_OPTIONS = ['ins_direct_pay', 'prem_fina_other'];
    const [showAdditionalIntMessage, setShowAdditionalInterestMessage] = useState(false);
    const [additionalInterest, setAdditionalInterest] = useState();
    const [additionalInterestDetail, setAdditionalInterestDetail] = useState();
    const [showSubmitLoader, setShowSubmitLoader] = useState(false);
    const additionalInterestContacts = submissionVM.value.baseData.policyContactDetails_TWIA
        .filter(c => c.policyContactRoles.some(pcr => pcr.subtype === 'PolicyAddlInterest'));
    const policyTypeCode = _.get(submissionVM, 'lobData.homeowners.policyType_TWIA.value.code');
    const ceUserName = _.get(submissionVM, 'bindData.registeredCEUsername_TWIA.value');
    const contactEmail = _.get(submissionVM, 'bindData.contactEmail');
    const [isAutoPayEnabled, setIsAutoPayEnabled] = useState(false);
    const [validatingEmail, setValidatingEmail] = useState(false);
    const autoPayEnabled = _.get(submissionVM, 'bindData.isAutoPayEnabled_TWIA.value');
    useEffect(() => {
        setIsAutoPayEnabled(autoPayEnabled)
    }, [])
    const getSelectedPaymentMethod = useCallback(() => (!eftEnabled
        // eslint-disable-next-line no-secrets/no-secrets
        ? _.get(submissionVM, `bindData.paymentDetails.nonEFTPaymentMethod_TWIA.value.code`)
        // eslint-disable-next-line no-secrets/no-secrets
        : _.get(submissionVM, `bindData.paymentDetails.paymentMethod_TWIA.value.code`)),
        [eftEnabled, submissionVM]);

    const getSelectedPaymentOption = useCallback(() => (!eftEnabled
        // eslint-disable-next-line no-secrets/no-secrets
        ? _.get(submissionVM, `bindData.paymentDetails.nonEFTPaymentOption_TWIA.value.code`)
        // eslint-disable-next-line no-secrets/no-secrets
        : _.get(submissionVM, `bindData.paymentDetails.paymentOption_TWIA.value.code`)),
        [eftEnabled, submissionVM]);

    const resetElectronicPaymentData = useCallback(() => {
        const epayData = _.get(submissionVM, 'bindData.paymentDetails.electronicPaymentData_TWIA');

        if (epayData && epayData.aspects && !epayData.aspects.subtreeValid) {
            // eslint-disable-next-line no-secrets/no-secrets
            _.set(submissionVM, 'bindData.paymentDetails.electronicPaymentData_TWIA.value', null);
            updateWizardData(submissionVM);
        }
    }, [submissionVM, updateWizardData]);

    const getAdditionalInterestData = useCallback((paymentMethod, ai) => {
        if (TWIASubmissionHelper.isHomeOwners(submissionVM.value)) {
            return TWIAPolicyContactRoleHelper.ho
                .policyAdditionalInterestAndContactDetailByPaymentMethod(paymentMethod)(ai);
        }

        if (TWIASubmissionHelper.isCommercialProperty(submissionVM.value)) {
            return TWIAPolicyContactRoleHelper.cp
                .policyAdditionalInterestAndContactDetailByPaymentMethod(paymentMethod)(ai);
        }

        return undefined;
    }, [submissionVM]);

    useEffect(() => {
        resetElectronicPaymentData();

        const paymentMethod = getSelectedPaymentMethod();

        setIsLoading(true);

        const bindDataCall = LoadSaveService.retrieveBindDataWithPaymentPlans_TWIA(jobID,
            sessionID, authHeader);

        bindDataCall.then((response) => {
            _.set(submissionVM, 'bindData.value', response);
            CustomQuoteService.maxAmountCanFinance(jobID, authHeader).then(amount => {
                // eslint-disable-next-line no-secrets/no-secrets
                _.set(submissionVM, 'bindData.paymentDetails.maximumFinancedAmount_TWIA.value',
                    amount || {});

                if (paymentMethod === 'echeck') {
                    submissionVM.bindData.paymentDetails.electronicPaymentData_TWIA.value =
                        submissionVM.bindData.paymentDetails.electronicPaymentData_TWIA.value || {}
                    updateWizardData(submissionVM);
                }

                updateWizardData(submissionVM);

                const result = getAdditionalInterestData(paymentMethod, additionalInterestContacts);

                setAdditionalInterest(() => result.additionalInterestContact);
                setAdditionalInterestDetail(() => result.additionalInterestDetail);
                setShowAdditionalInterestMessage(() => _.isEmpty(result.additionalInterestDetail));
                setBindDataVM(() => _.get(submissionVM, 'bindData'));
                setIsLoading(false);
            });
        })
    }, [])

    const getPremiumValue = useCallback(() => offeredQuoteData ?
        offeredQuoteData.premium.total : null, [offeredQuoteData]);


    const effectiveDateChange = useCallback(() => {
        if (steps.length === 1) {
            let periodStart = _.get(submissionVM, 'baseData.periodStartDate.value');
            if (submissionVM?.value?.baseData?.periodStatus === 'Submitted_Ext' && periodStart) {
                periodStart = LocalDateUtil.toMidnightDate(periodStart);
                const now = new Date();
                if (now > periodStart) {
                    submissionVM.baseData.periodStartDate.value = {
                        year: now.getFullYear(),
                        month: now.getMonth(),
                        day: now.getDate()
                    };
                }
            }
            updateWizardData(submissionVM);
        }
    }, [steps, submissionVM, updateWizardData])

    const onChangePaymentMethod = useCallback((value, path) => {
        _.set(bindDataVM, path, value);
        _.set(submissionVM, 'bindData.isAutoPayEnabled_TWIA.value', false);

        if (value !== 'echeck') {
            disregardFieldValidation('Echeck');
            disregardFieldValidation('TWIAAddressComponent');
        }
        effectiveDateChange();
        setIsLoading(true);
        
        const job = _.cloneDeep(submissionVM.value);
        job.bindData.paymentDetails.electronicPaymentData_TWIA = null;
        LoadSaveService.retrievePaymentPlansBySubmission(job, authHeader)
        .then(paymentPlans => {
            if (_.includes(NO_PAYMENT_OPTION_METHODS, value) && !eftEnabled) {
                _.set(bindDataVM, 'paymentDetails.nonEFTPaymentOption_TWIA.value', undefined);
            } else if (_.includes(NO_PAYMENT_OPTION_METHODS, value)) {
                _.set(bindDataVM, 'paymentDetails.paymentOption_TWIA.value', undefined);
            } else if (value === 'mortgagee_escrow' && !eftEnabled) {
            _.set(bindDataVM, 'paymentDetails.nonEFTPaymentOption_TWIA.value', 'mortgagee_billed');
            } else if (value === 'mortgagee_escrow') {
                _.set(bindDataVM, 'paymentDetails.paymentOption_TWIA.value', 'mortgagee_billed');
            }
            _.set(bindDataVM, 'paymentPlans.value', paymentPlans);
            _.set(submissionVM, 'bindData', bindDataVM);
            updateWizardData(submissionVM);

            const result = getAdditionalInterestData(value, additionalInterestContacts);

            setAdditionalInterest(() => result.additionalInterestContact);
            setAdditionalInterestDetail(() => result.additionalInterestDetail);
            setShowAdditionalInterestMessage(() => _.isEmpty(result.additionalInterestDetail));
            setBindDataVM(() => bindDataVM);
            setIsLoading(false);
        });
    }, [additionalInterestContacts, authHeader, bindDataVM, disregardFieldValidation,
        getAdditionalInterestData, submissionVM, updateWizardData]);

    const onViewPaymentPlan = useCallback((rowData) => {
        const componentProps = {
            title: translator(messages.installmentPopupTitle),
            submissionVM,
            authHeader,
            rowData
        };

        showModal(
            <InstallmentsPopup {...componentProps} />
        );
    }, [authHeader, showModal, submissionVM, translator]);

    const onChangeEmail = useCallback((event, email) => {
        setIsLoading(true);
        // eslint-disable-next-line no-secrets/no-secrets
        _.set(submissionVM, 'bindData.contactEmailNotProducerEmail_TWIA.value', true);

        if (!_.isUndefined(email.value)) {
            try {
                CustomQuoteService.isProducerEmail(email.value, authHeader).then((response) => {
                    // eslint-disable-next-line no-secrets/no-secrets
                    _.set(submissionVM, 'bindData.contactEmailNotProducerEmail_TWIA.value', !response);
                    setIsLoading(false);
                    if (response) {
                        setShowError(true);
                        setEmailMessage([translator(messages.producerEmailError)]);
                    } else {
                        setValidatingEmail(false);
                    }
                })
            } catch(err) {
                setValidatingEmail(false);
            }
        } else {
            // eslint-disable-next-line no-secrets/no-secrets
            _.set(submissionVM, 'bindData.contactEmailNotProducerEmail_TWIA.value', true);
        }

        setIsLoading(false);
        updateWizardData(submissionVM);
        setBindDataVM(() => _.get(submissionVM, 'bindData'));
    }, [authHeader, submissionVM, updateWizardData, translator]);

    const showPaymentMethod = useCallback(() => {
        const selectedPaymentMethod = getSelectedPaymentMethod()

        return !_.includes(NO_PAYMENT_OPTION_METHODS, selectedPaymentMethod)
    }, [NO_PAYMENT_OPTION_METHODS, getSelectedPaymentMethod])

    const navigateToAdditionalInfoScreen = useCallback(() => {
        showConfirm({
            title: wizardMessages.TWIAWizardModalTitle,
            message: wizardMessages.TWIAWizardModalMessage,
            status: 'warning',
            icon: 'mi-error-outline',
            confirmButtonText: wizardMessages.TWIAWizardModalConfirm,
            cancelButtonText: wizardMessages.TWIAWizardModalCancel,
            // eslint-disable-next-line consistent-return
        }).then((results) => {
            if (results === 'cancel' || results === 'close') {
                return _.noop();
            }

            // DE16417
            resetElectronicPaymentData();

            if (TWIASubmissionHelper.isHomeOwners(submissionVM.value)) {
                jumpTo(5);
            } else {
                jumpTo(4);
            }
        }, _.noop)
    }, [jumpTo, resetElectronicPaymentData, showConfirm, submissionVM]);

    const getAdditionalInterestMessage = useCallback(() => {
        
        if(getSelectedPaymentMethod() === 'prem_fina_other') {

            return TWIASubmissionHelper.isHomeOwners(submissionVM.value) ? (
                translator(messages.additionalMessagePF, {
                    Link: chunks => <Link className={styles.linkStyle} onClick={() => { navigateToAdditionalInfoScreen() }}>{chunks}</Link>
                })
            ) : (
                translator(messages.commercialPfMessage, {
                    Link: chunks => <Link className={styles.linkStyle} onClick={() => { navigateToAdditionalInfoScreen() }}>{chunks}</Link>
                })
            )
        }

        if (getSelectedPaymentMethod() === 'mortgagee_escrow') {

            return TWIASubmissionHelper.isHomeOwners(submissionVM.value) ? (
                translator(messages.additionalMessageMortgagee, {
                    Link: chunks => <Link className={styles.linkStyle} onClick={() => { navigateToAdditionalInfoScreen('mortgageee') }}>{chunks}</Link>
                })
            ) : (translator(messages.commercialMortgageMessage))
        }

        return null;
    }, [getSelectedPaymentMethod, navigateToAdditionalInfoScreen, submissionVM, translator]);

    // DE16427 is the selected payment plan autodraft
    const isAutoPay = useCallback(() => {
        const paymentPlans = _.get(submissionVM, 'bindData.paymentPlans.value');
        const selectedPlan = _.get(submissionVM, 'bindData.selectedPaymentPlan.value');
        let autoPay = false;

        if (paymentPlans && selectedPlan) {
            const selectedPaymentPlan = _.find(paymentPlans, plan => plan.billingId === selectedPlan);

            autoPay = _.get(selectedPaymentPlan, 'autoDraftPlan_TWIA');
        }

        return autoPay;
    }, [submissionVM]);

    _.set(submissionVM, 'bindData.isAutoPayEnabled_TWIA.value', isAutoPay());

    const writeValue = useCallback((value, path) => {
        _.set(bindDataVM, path, value);
        _.set(submissionVM, 'bindData', bindDataVM);
        if(_.includes(path, 'Option_TWIA') && value !== 'echeck'){
            disregardFieldValidation('Echeck');
            disregardFieldValidation('TWIAAddressComponent');
        }
        // DE16427 set autopay to make email required or not
        _.set(submissionVM, 'bindData.isAutoPayEnabled_TWIA.value', isAutoPay());

        setEmailMessage([]);

        if (!_.isNil(ceUserName) && contactEmail && !contactEmail.aspects.valid) {
            setEmailMessage([translator(messages.policyholderEmailRequired)])
            setShowError(true);
            // DE17818
        } else if (!isAutoPay() && _.isNil(contactEmail?.value) && contactEmail.aspects.required) {
            setEmailMessage([translator(messages.required)]);
            setShowError(true);
        } else if (!isAutoPay() && contactEmail && !contactEmail.aspects.valid) {
            setEmailMessage([translator(messages.emailValidationMessage)]);
            setShowError(true);
        } else if (isAutoPay() && contactEmail && !contactEmail.aspects.valid) {
            setEmailMessage([translator(messages.validate10PayEmail)]);
            // DE16573 show missing email error
            setShowError(true);
        }
        if (path === 'contactEmail') {
            setValidatingEmail(true);
        }

        updateWizardData(submissionVM);
        setBindDataVM(() => _.get(submissionVM, 'bindData'));
    }, [bindDataVM, disregardFieldValidation, isAutoPay, submissionVM, translator, 
        updateWizardData, ceUserName, contactEmail]);
    
    // DE16426
    const getPaymentMethods = useCallback((method) => {
        if (policyTypeCode === "TWRP") {
            const filteredPaymentMethods = _.filter(_.get(bindDataVM, `paymentDetails.${method}.aspects.availableValues`),
                (pm) => pm.code !== 'mortgagee_escrow')
            return filteredPaymentMethods.map(key => ({
                name: translator({
                    id: key.name,
                    defaultMessage: key.name,
                }),
                code: key.code,
            }))
        }
        return _.get(bindDataVM, `paymentDetails.${method}.aspects.availableValues`).map(key => ({
            name: translator({
                id: key.name,
                defaultMessage: key.name,
            }),
            code: key.code,
        }))

    }, [bindDataVM, policyTypeCode, translator]);


    const overrideProps = {
        '@field': {
            showOptional: false,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        paymentPlansTable: {
            bindDataVM,
            writeValue,
            onViewPaymentPlan
        },
        totalPremium: {
            value: getPremiumValue()
        },
        playmentPlanText: {
            content: translator(messages.paymentPlanText)
        },
        paymentMethodWithEft: {
            visible: eftEnabled,
            availableValues:getPaymentMethods('paymentMethod_TWIA')
        },
        paymentMethod: {
            visible: !eftEnabled,
            availableValues:getPaymentMethods('nonEFTPaymentMethod_TWIA')
        },
        paymentOptionWithEft: {
            visible: eftEnabled && showPaymentMethod()
        },
        paymentOption: {
            visible: !eftEnabled && showPaymentMethod()
        },
        additionalInterestText: {
            visible: _.includes(ADDITIONAL_INTEREST_OPTIONS, getSelectedPaymentMethod())
                && showAdditionalIntMessage,
            message: getAdditionalInterestMessage()
        },
        pfMessageText: {
            visible: getSelectedPaymentMethod() === 'prem_fina_other' && !showAdditionalIntMessage,
            content: translator(messages.pfMessage)
        },
        aiName: {
            visible: !_.isUndefined(additionalInterest) && _.includes(ADDITIONAL_INTEREST_OPTIONS,
                getSelectedPaymentMethod()),
            label: getSelectedPaymentMethod() === 'prem_fina_other'
                ? translator(messages.pfCompany) : translator(messages.mortgagee),
            value: additionalInterest?.displayName
        },
        loanNumber: {
            visible: !_.isUndefined(additionalInterestDetail) && !_.isEmpty(additionalInterest)
                && _.includes(ADDITIONAL_INTEREST_OPTIONS, getSelectedPaymentMethod()),
            value: additionalInterestDetail?.contractNumber
        },
        tenPayMsg: {
            visible: isAutoPay(),
            message: translator(messages.tenPayMsg)
        },
        echeckDetails: {
            visible: !_.isUndefined(bindDataVM.paymentDetails.electronicPaymentData_TWIA.value)
                && (getSelectedPaymentMethod() === 'echeck' || getSelectedPaymentOption() === 'echeck'),
            bindDataVM,
            writeValue,
            onValidate,
            showError
        },
        emailAddress: {
            required: isAutoPay() || !_.isNil(ceUserName) || isAutoPayEnabled,
            showRequired: isAutoPay() || !_.isNil(ceUserName) || isAutoPayEnabled,
            validationMessages: emailMessage
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onChangePaymentMethod,
            writeValue,
            onChangeEmail
        },
        resolveComponentMap: {
            paymentPlansTableComponent: PaymentPlansTable,
            echeckDetailsComponent: Echeck
        },
        resolveClassNameMap: styles
    };

    const handleNext = useCallback(() => {
        showConfirm({
            title: messages.confirmTransaction,
            message: messages.confirmTransactionMsg,
            status: 'warning',
            icon: 'gw-help',
            confirmButtonText: commonMessages.ok,
            cancelButtonText: commonMessages.cancelModel,
            // eslint-disable-next-line consistent-return
        }).then((results) => {
            if (results === 'cancel' || results === 'close') {
                return _.noop();
            }

            setShowSubmitLoader(true);

            const checkUwIssues = CustomQuoteService.getUWIssueStatus(jobID, sessionID, authHeader);

            checkUwIssues.then((result) => {
                console.log(result);

                // US26432
                if (result.anyPolicyHoldUWIssues) {
                    setShowSubmitLoader(false);
                    showAlert({
                        title: '',
                        message: messages.uwPolicyHold_twia,
                        status: 'error',
                        icon: 'mi-error-outline',
                        cancelButtonText: commonMessages.cancelModel,
                    }).then((res) => {
                        if (res === 'confirm') {
                            // 2024-12-29 - Debra Frum - DE17673 - Suppress the Exit confirmation popup
                            submissionVM.noCancelWarning = true;
                            // DE15535 
                            history.push(`${process.env.PUBLIC_PATH}/quotes/${submissionVM.quoteID.value}/summary`)
                        }
                    })
                }
                else if (result.anyOtherBlockingUWIssues) {
                    setShowSubmitLoader(false);
                    showAlert({
                        title: '',
                        message: messages.uwOtherBlockingIssue_twia,
                        status: 'error',
                        icon: 'mi-error-outline',
                        cancelButtonText: commonMessages.cancelModel,
                    }).then((res) => {
                        if (res === 'confirm') {
                            // 2024-12-29 - Debra Frum - DE17673 - Suppress the Exit confirmation popup
                            submissionVM.noCancelWarning = true;
                            // DE15535 
                            history.push(`${process.env.PUBLIC_PATH}/quotes/${submissionVM.quoteID.value}/summary`)
                        }
                    })
                }
                else {
                    // DE18289
                    
                    effectiveDateChange();
                    const job = _.cloneDeep(submissionVM.value);

                    if (getSelectedPaymentMethod() !== 'echeck' && getSelectedPaymentOption() !== 'echeck') {
                        job.bindData.paymentDetails.electronicPaymentData_TWIA = null
                    }

                    const submit = LoadSaveService.submitOrBind_TWIA(job, authHeader);

                    submit.then((response) => {
                        const electronicData = submissionVM.bindData.paymentDetails.electronicPaymentData_TWIA.value;

                        submissionVM.value = response;
                        submissionVM.bindData.paymentDetails.electronicPaymentData_TWIA.value =
                            electronicData || {}
                        updateWizardData(submissionVM)
                        // setShowSubmitLoader(false);
                        submissionVM.noCancelWarning = true;
                        if (TWIASubmissionHelper.isHomeOwners(submissionVM.value)) {
                            return history.push({
                                pathname: '/twiaResConfirmation',
                                state: {
                                    response,
                                    authHeader
                                },
                            });
                        }
                        return history.push({
                            pathname: '/quoteConfirmation',
                            state: {
                                response,
                                authHeader
                            },
                        });


                    }).catch((err) => {
                        setShowSubmitLoader(false);

                        const errorMessage = _.split(err.baseError, 'ErrorMessage: ')[1];
                        const errorCode = _.get(err, 'appErrorCode');

                        if (errorMessage.includes("Getting Time Out to Pay and Issue process for job") ||
                            errorMessage.includes("Error occurred during Pay and Issue process for job")) {
                            showAlert({
                                title: commonMessages.genericError,
                                message: messages.unableToProcessPayment,
                                status: 'error',
                                icon: 'mi-error-outline',
                                confirmButtonText: commonMessages.ok,
                            })
                        } else {

                            switch (errorCode) {
                                case 10075:
                                    showAlert({
                                        title: messages.invalidBank,
                                        message: messages.badBank,
                                        status: 'error',
                                        icon: 'mi-error-outline',
                                        confirmButtonText: commonMessages.ok,
                                    })
                                    break;
                            case 10074:
                                showAlert({
                                    title: messages.paymentThreshold,
                                    message: messages.paymentThresholdMsg,
                                    status: 'error',
                                    icon: 'mi-error-outline',
                                    confirmButtonText: commonMessages.ok,
                                })
                                break;
                            case 10082:
                                showAlert({
                                    title: messages.paymentThreshold,
                                    message: messages.paymentThresholdMsgR352,
                                    status: 'error',
                                    icon: 'mi-error-outline',
                                    confirmButtonText: commonMessages.ok,
                                })
                                break;
                            case 602:
                                    setShowSubmitLoader(false);
                                    showAlert({
                                        title: '',
                                        message: messages.uwOtherBlockingIssue_twia,
                                        status: 'error',
                                        icon: 'mi-error-outline',
                                        cancelButtonText: commonMessages.cancelModel,
                                    }).then((res) => {
                                        if (res === 'confirm') {
                                            // 2024-12-29 - Debra Frum - DE17673 - Suppress the Exit confirmation popup
                                            submissionVM.noCancelWarning = true;
                                            // DE15535 
                                            history.push(`${process.env.PUBLIC_PATH}/quotes/${submissionVM.quoteID.value}/summary`)
                                        }
                                    })
                                    break;
                            default:
                                ErrorPopupUtil.showSaveErrorPopup(showAlert, true);
                                break;
                        }
                    }
                        
                        return false;
                        
                    });
                }
            }, _.noop)
        })
    }, [authHeader, getSelectedPaymentMethod, getSelectedPaymentOption, history, 
        jobID, sessionID, showAlert, showConfirm, submissionVM, updateWizardData]);

    // DE16630 
     //const paymentOption = _.get(bindDataVM, 'paymentDetails.nonEFTPaymentOption_TWIA.value.code')

    // logic to handle disableNext 
    // Submit button should be enabled if the user switches the Payment Option from eCheck to other Payment option.
    const isNextDisabled = useCallback(() => {
        if((_.includes(DISABLE_SUBMIT_OPTIONS, getSelectedPaymentMethod())
            || getSelectedPaymentOption() === 'mortgagee_billed')
            && _.get(submissionVM, 'baseData.periodStatus.value.code') === 'Submitted_Ext'){
            return true
        }
        const isAdditionalInterestSelected = _.includes(ADDITIONAL_INTEREST_OPTIONS, getSelectedPaymentMethod()) && showAdditionalIntMessage;

        return (!isComponentValid) || isAdditionalInterestSelected || validatingEmail;
    }, [DISABLE_SUBMIT_OPTIONS, getSelectedPaymentMethod, getSelectedPaymentOption, 
        submissionVM, ADDITIONAL_INTEREST_OPTIONS, showAdditionalIntMessage, isComponentValid, validatingEmail]);


    return (
        <WizardPage
            nextLabel={messages.paymentBuyNow}
            showNext={!showSubmitLoader}
            showPrevious={submissionVM.baseData.periodStatus.value.code === 'Submitted_Ext' ? false : !showSubmitLoader}
            showCancel={!showSubmitLoader}
            hideHeader={showSubmitLoader}
            onNext={handleNext}
            // US26294
            onPrevious={resetElectronicPaymentData}
            // DE16417
            disableNext={isNextDisabled()}
            disablePrevious={validatingEmail}
            
        >
            {!showSubmitLoader ? 
            (<Loader loaded={!isLoading}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={bindDataVM}
                    onModelChange={updateWizardData}
                    overrideProps={overrideProps}
                    onValidationChange={onValidate}
                    classNameMap={resolvers.resolveClassNameMap}
                    componentMap={resolvers.resolveComponentMap}
                    callbackMap={resolvers.resolveCallbackMap}
                    showErrors={showError}
                />
            </Loader>) : 
            (<Loader
                loaded={!showSubmitLoader}
                text="Processing Transaction..."
            />)}
        </WizardPage>
    );
}

TWIAPaymentDetailsPage.propTypes = wizardProps;
export default TWIAPaymentDetailsPage;
